import React from "react";
import { connect } from "react-redux";
import {
  toggleSidebar,
  logout,
  logoutforCustom,
} from "../redux/actions/sidebarActions";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import "./logo.scss";
import * as myConstClass from "../constant.js";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {
  Row,
  Col,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
  Form,
  Button,
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faEnvelopeOpen,
  faCog,
  faArrowAltCircleRight,
  faExclamationTriangle,
  faShoppingCart,
  faHandsHelping,
  faBook,
  faWeight,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import { T, TF, LanguageList, Config } from "react-translator-component";

Config.list = {
  en: {
    text: "English",
    file: require("../locale/en.js"),
  },
  KH: {
    text: "Khmer",
    file: require("../locale/KH.js"),
  },
  ch: {
    text: "Chinese",
    file: require("../locale/ch.js"),
  },
};
//localStorage.removeItem("lang");
Config.default = localStorage.getItem("lang");

const NavbarDropdown = ({
  children,
  count,
  header,
  footer,
  icon,
  active,
  indicator,
}) => (
  <UncontrolledDropdown nav inNavbar className="ml-lg-1" active={active}>
    <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
      <FontAwesomeIcon icon={icon} className="align-middle" />
      {indicator ? <span className="indicator" /> : ""}
    </DropdownToggle>
    <DropdownMenu right className="dropdown-menu-lg py-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      <ListGroup>{children}</ListGroup>
      <DropdownItem header className="dropdown-menu-footer">
        <span className="text-muted">{footer}</span>
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

const NavbarToggle = connect((store) => ({
  app: store.app,
}))(({ dispatch }) => {
  return (
    <span
      className="sidebar-toggle d-flex mr-2"
      onClick={() => {
        dispatch(toggleSidebar());
      }}
    >
      <i className="hamburger align-self-center" />
    </span>
  );
});

const NavbarSearch = connect((store) => ({
  sidebar: store.sidebar,
}))(() => {
  return (
    <Form inline>
      {/* <Input
        type="text"
        placeholder="Search projects..."
        aria-label="Search"
        className={classNames(
          "form-control-lite",
          !sidebar.isOnRight || "text-right"
        )}

      /> */}
    </Form>
  );
});

class Navbarnew extends React.Component {
  constructor(props) {
    super(props);
    this.edit = this.edit.bind(this);
    this.googleTranslateElementInit =
      this.googleTranslateElementInit.bind(this);
    this.state = {};
    this.state = {
      issueLength: 0,
      empData: [],
      msgcount: "",
      ordercount: "",
      complaintcount: "",
      leavecount: "",
      documentcount: "",
      pro_package: "",
      unseencount: "",
    };
  }

  // componentDidMount() {
  //   // alert(localStorage.getItem("common_login"));
  //   //alert(localStorage.getItem("custom"));
  //   //window.location.reload(false);
  //   //alert(localStorage.getItem("is_custom"));
  //   window.googleTranslateElementInit = this.googleTranslateElementInit;
  //   const script = document.createElement("script");
  //   script.src =
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //   script.async = true;
  //   document.body.appendChild(script);
  //   var admin_id = localStorage.getItem("uname");
  //   let login_id = localStorage.getItem("login_id");
  //   var login_type = localStorage.getItem("login_type");

  //   //alert(localStorage.getItem("lang"));

  //   fetch(myConstClass.BASE_URL + "attendance/getEmployeeIssues/0/1")
  //     .then((response) => response.json())
  //     .then((response) => {
  //       let i = 1;

  //       this.setState({ issueLength: response.length });
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadunseenCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ unseencount: response });
  //       //localStorage.setItem('mcount',response);
  //       //lert(response);
  //     })
  //     .catch((err) => console.log(err));

  //   // var mcount= localStorage.getItem('mcount');
  //   // var ocount= localStorage.getItem('ocount');
  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadMessagesCountOld/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       //localStorage.setItem('mcount',response);
  //       this.setState({ msgcount: response });
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadOrderCount/" +
  //       admin_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       //const notifications = [];
  //       //this.setState({leave_types: response})

  //       //alert(response);
  //       //alert(response);

  //       this.setState({ ordercount: response });
  //       //localStorage.setItem('ocount',response);
  //       //alert(mcount);
  //       /*    toastr.info(
  //                           'Message',
  //                           "You have a new message",
  //                           this.options
  //                         ) */
  //     })
  //     .catch((err) => console.log(err));
  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadComplaintCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ complaintcount: response });
  //       //localStorage.setItem('mcount',response);
  //       //lert(response);
  //     })
  //     .catch((err) => console.log(err));

  //   //this.interval = setInterval(() => this.tick(), 1000);

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadLeaveCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ leavecount: response });
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadDocumentCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ documentcount: response });
  //     })
  //     .catch((err) => console.log(err));
  // }

  // tick() {
  //   // alert('hii');
  //   var admin_id = localStorage.getItem("uname");
  //   var login_type = localStorage.getItem("login_type");
  //   var login_id = localStorage.getItem("login_id");

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadunseenCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ unseencount: response });
  //       //localStorage.setItem('mcount',response);
  //       //lert(response);
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(myConstClass.BASE_URL + "attendance/getEmployeeIssues/0/1")
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ issueLength: response.length });
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadComplaintCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ complaintcount: response });
  //       //localStorage.setItem('mcount',response);
  //       //lert(response);
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadLeaveCount/" +
  //       admin_id +
  //       "/" +
  //       login_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({ leavecount: response });
  //       //localStorage.setItem('mcount',response);
  //       //lert(response);
  //     })
  //     .catch((err) => console.log(err));

  //   fetch(
  //     myConstClass.BASE_URL +
  //       "user/getunreadOrderCount/" +
  //       admin_id +
  //       "/" +
  //       login_type
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       //const notifications = [];
  //       //this.setState({leave_types: response})

  //       //alert(response);
  //       //alert(response);

  //       this.setState({ ordercount: response });
  //       //localStorage.setItem('ocount',response);
  //       //alert(mcount);
  //       /*    toastr.info(
  //                          'Message',
  //                          "You have a new message",
  //                          this.options
  //                        ) */
  //     })
  //     .catch((err) => console.log(err));
  // }

  // googleTranslateElementInit() {
  //   /* eslint-disable no-new */
  //   const google = window.google;
  //   // new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, autoDisplay: false, multilanguagePage: true}, 'google_translate_element');
  //   new google.translate.TranslateElement(
  //     { pageLanguage: "en" },
  //     "google_translate_elementnav"
  //   );
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "pt",
  //       layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
  //     },
  //     "google_translate_elementnav"
  //   );
  // }

  // change_dashboard(type) {
  //  // alert(type);

  //   if (type == "1") {
  //     localStorage.setItem("on_subadmin_dashboard", "1");
  //   localStorage.setItem("login_type", "sub_admin");
  //   localStorage.setItem("is_subadmin", "0");
  //     localStorage.setItem("is_sub_admin_with_payroll", "1");
  //     window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
  //   } else if (type == "2") {
  //     localStorage.setItem("on_subadmin_dashboard", "1");
  //      localStorage.setItem("login_type", "sub_admin");
  //      localStorage.setItem("is_subadmin", "0");
  //     localStorage.setItem("is_sub_admin_with_payroll", "2");
  //     window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
  //   }
  //   else{
  //     localStorage.setItem("on_subadmin_dashboard", "2");

  //     var is_payroll_privilage = localStorage.getItem("is_payroll_privilage");
  //     //alert(is_payroll_privilage);
  //     if(is_payroll_privilage!='0')
  //     {
  //       localStorage.setItem("login_type", "emp");
  //       localStorage.setItem("is_payroll_privilage", "1");
  //     }
  //     else{
  //       localStorage.setItem("is_subadmin", "1");
  //       localStorage.setItem("login_type", "emp");
  //       localStorage.setItem("is_payroll_privilage", "0");
  //     }

  //     //localStorage.setItem("is_sub_admin_with_payroll", "0");
  //     window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "employees/profileinfo";
  //   }

  //   // var tenant_url = localStorage.getItem('url');
  //   // file_ten_path = tenant_url+'dashboard';
  //   // window.location.href = file_ten_path;

  // }

  // change_common_url() {
  //   localStorage.clear();
  //   window.location.href = "https://wzonekh.com/dashboard.php";
  // }

  // change_custom() {
  //   //alert('hii');

  //   //localStorage.setItem("login_type", "sub_admin");
  //   localStorage.setItem("login_type", "hr_admin");
  //   localStorage.setItem("custom", "1");
  //   // if (type == "1") {
  //   //   localStorage.setItem("is_sub_admin_with_payroll", "1");
  //   // } else {
  //   //   localStorage.setItem("is_sub_admin_with_payroll", "2");
  //   // }

  //   // var tenant_url = localStorage.getItem('url');
  //   // file_ten_path = tenant_url+'dashboard';
  //   // window.location.href = file_ten_path;

  //   window.location.href =
  //     "/" + myConstClass.TENANT_PAGE_PATH + "reportscustom/listing";
  // }

  // edit(e) {
  //   //alert(e);
  //   var add_msg = localStorage.getItem("view_msg");
  //   var login_type = localStorage.getItem("login_type");

  //   if (e == "complaint") {
  //     var empleave_add = localStorage.getItem("comnot");

  //     if (
  //       (empleave_add == "0" && login_type !== "hr_admin") ||
  //       (empleave_add == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     fetch(myConstClass.BASE_URL + "user/getunreadunseenCountcomplaint")
  //       .then((response) => response.json())
  //       .then(() => {})
  //       .catch((err) => console.log(err));
  //     window.location.href =
  //       "/" + myConstClass.TENANT_PAGE_PATH + "employeescomplaints/listing";
  //   }

  //   if (e == "issue") {
  //     var empleave_add = localStorage.getItem("issue");

  //     if (
  //       (empleave_add == "0" && login_type !== "hr_admin") ||
  //       (empleave_add == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     // fetch(myConstClass.BASE_URL + "user/getunreadunseenCountcomplaint")
  //     //   .then((response) => response.json())
  //     //   .then(() => {})
  //     //   .catch((err) => console.log(err));
  //     window.location.href =
  //       "/" + myConstClass.TENANT_PAGE_PATH + "employeesissues/listing";
  //   }

  //   if (e == "document") {
  //     var empleave_add = localStorage.getItem("docnot");

  //     if (
  //       (empleave_add == "0" && login_type !== "hr_admin") ||
  //       (empleave_add == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     fetch(myConstClass.BASE_URL + "user/getunreadDocumentCount")
  //       .then((response) => response.json())
  //       .then(() => {})
  //       .catch((err) => console.log(err));
  //     window.location.href =
  //       "/" +
  //       myConstClass.TENANT_PAGE_PATH +
  //       "employeesadmin_staff/listingdocs";
  //   }

  //   if (e == "msg") {
  //     var empleavenot = localStorage.getItem("msgnot");
  //     //alert(empleave_add);
  //     if (
  //       (empleavenot == "0" && login_type !== "hr_admin") ||
  //       (empleavenot == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     fetch(myConstClass.BASE_URL + "user/getunreadunseenCountmsg")
  //       .then((response) => response.json())
  //       .then(() => {})
  //       .catch((err) => console.log(err));
  //     window.location.href =
  //       "/" + myConstClass.TENANT_PAGE_PATH + "empmsg/listing";
  //   }

  //   if (e == "order") {
  //     var empleavenot = localStorage.getItem("ordernot");
  //     //alert(empleave_add);
  //     if (
  //       (empleavenot == "0" && login_type !== "hr_admin") ||
  //       (empleavenot == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     window.location.href =
  //       "/" + myConstClass.TENANT_PAGE_PATH + "shopsorder/listing";
  //   }

  //   if (e == "leave") {
  //     var empleavenot = localStorage.getItem("leavenot");
  //     //alert(empleave_add);
  //     if (
  //       (empleavenot == "0" && login_type !== "hr_admin") ||
  //       (empleavenot == null && login_type !== "hr_admin") ||
  //       login_type == "emp" ||
  //       login_type == "security"
  //     ) {
  //       // alert('hii')
  //       toastr.error(TF("{0}", T("Error")), add_msg);
  //       return;
  //     }

  //     fetch(myConstClass.BASE_URL + "user/getunreadunseenCountleave")
  //       .then((response) => response.json())
  //       .then(() => {})
  //       .catch((err) => console.log(err));

  //     window.location.href =
  //       "/" + myConstClass.TENANT_PAGE_PATH + "shiftsleaves/listing";
  //   }
  // }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }
  // show_qrcode(e) {
  //   // alert('signup');
  //   // e.preventDefault();
  //   //this.props.history.push('/signup');
  //   localStorage.setItem("custom", "1");
  //   window.location.href = "/SignInCustom";
  // }

  componentDidMount() {
    window.googleTranslateElementInit = this.googleTranslateElementInit;
    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");

    const endpoints = [
      {
        url: "attendance/getEmployeeIssues/0/1",
        callback: (data) => this.setState({ issueLength: data.length }),
      },
      {
        url: `user/getunreadunseenCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ unseencount: data }),
      },
      {
        url: `user/getunreadMessagesCountOld/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ msgcount: data }),
      },
      {
        url: `user/getunreadOrderCount/${admin_id}/${login_type}`,
        callback: (data) => this.setState({ ordercount: data }),
      },
      {
        url: `user/getunreadComplaintCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ complaintcount: data }),
      },
      {
        url: `user/getunreadLeaveCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ leavecount: data }),
      },
      {
        url: `user/getunreadDocumentCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ documentcount: data }),
      },
      {
        url: `user/getunreadunseenCountOt/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ otcount: data }),
      },
    ];

    this.performFetchRequests(endpoints);

    // this.interval = setInterval(() => this.tick(), 10000); // Optional
  }

  tick() {
    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");

    const endpoints = [
      {
        url: `user/getunreadunseenCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ unseencount: data }),
      },
      {
        url: "attendance/getEmployeeIssues/0/1",
        callback: (data) => this.setState({ issueLength: data.length }),
      },
      {
        url: `user/getunreadComplaintCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ complaintcount: data }),
      },
      {
        url: `user/getunreadLeaveCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ leavecount: data }),
      },
      {
        url: `user/getunreadOrderCount/${admin_id}/${login_type}`,
        callback: (data) => this.setState({ ordercount: data }),
      },
    ];

    this.performFetchRequests(endpoints);
  }

  performFetchRequests = (requests) => {
    requests.forEach(({ url, callback }) => {
      fetch(`${myConstClass.BASE_URL}${url}`)
        .then((res) => res.json())
        .then(callback)
        .catch((err) => console.error(`Error fetching ${url}:`, err));
    });
  };

  googleTranslateElementInit() {
    const google = window.google;
    if (!google?.translate) return;

    new google.translate.TranslateElement(
      { pageLanguage: "en" },
      "google_translate_elementnav"
    );
    new google.translate.TranslateElement(
      {
        pageLanguage: "pt",
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      "google_translate_elementnav"
    );
  }

  // change_dashboard(type) {
  //   if (type === "1" || type === "2") {
  //     localStorage.setItem("on_subadmin_dashboard", "1");
  //     localStorage.setItem("login_type", "sub_admin");
  //     localStorage.setItem("is_subadmin", "0");
  //     localStorage.setItem("is_sub_admin_with_payroll", type);
  //     window.location.href = `/${myConstClass.TENANT_PAGE_PATH}dashboard`;
  //   } else {
  //     localStorage.setItem("on_subadmin_dashboard", "2");

  //     const is_payroll_privilage = localStorage.getItem("is_payroll_privilage");
  //     if (is_payroll_privilage !== "0") {
  //       localStorage.setItem("login_type", "emp");
  //       localStorage.setItem("is_payroll_privilage", "1");
  //     } else {
  //       localStorage.setItem("is_subadmin", "1");
  //       localStorage.setItem("login_type", "emp");
  //       localStorage.setItem("is_payroll_privilage", "0");
  //     }

  //     window.location.href = `/${myConstClass.TENANT_PAGE_PATH}employees/profileinfo`;
  //   }
  // }

   change_dashboard(type) {
     // alert(type);
      
      if (type == "1") {
        localStorage.setItem("on_subadmin_dashboard", "1");
      localStorage.setItem("login_type", "sub_admin");
      localStorage.setItem("is_subadmin", "0");
        localStorage.setItem("is_sub_admin_with_payroll", "1");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
      } else if (type == "2") {
        localStorage.setItem("on_subadmin_dashboard", "1");
         localStorage.setItem("login_type", "sub_admin");
         localStorage.setItem("is_subadmin", "0");
        localStorage.setItem("is_sub_admin_with_payroll", "2");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
      }
      else{
        localStorage.setItem("on_subadmin_dashboard", "2");
        
        var is_payroll_privilage = localStorage.getItem("is_payroll_privilage");
        //alert(is_payroll_privilage);
        if(is_payroll_privilage!='0')
        {
          localStorage.setItem("login_type", "emp");
          localStorage.setItem("is_payroll_privilage", "1");
        }
        else{
          localStorage.setItem("is_subadmin", "1");
          localStorage.setItem("login_type", "emp");
          localStorage.setItem("is_payroll_privilage", "0");
        }
        
  
        //localStorage.setItem("is_sub_admin_with_payroll", "0");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "employees/profileinfo";
      }
  
      // var tenant_url = localStorage.getItem('url');
      // file_ten_path = tenant_url+'dashboard';
      // window.location.href = file_ten_path;
  
     
    }

  change_common_url() {
    localStorage.clear();
    window.location.href = "https://wzonekh.com/dashboard.php";
  }

  change_custom() {
    localStorage.setItem("login_type", "hr_admin");
    localStorage.setItem("custom", "1");
    window.location.href = `/${myConstClass.TENANT_PAGE_PATH}reportscustom/listing`;
  }

  edit(e) {
    const add_msg = localStorage.getItem("view_msg");
    const login_type = localStorage.getItem("login_type");

    const checkPermission = (permKey) =>
      (localStorage.getItem(permKey) === "0" && login_type !== "hr_admin") ||
      (!localStorage.getItem(permKey) && login_type !== "hr_admin") ||
      login_type === "emp" ||
      login_type === "security";

    const routes = {
      complaint: "employeescomplaints/listing",
      issue: "employeesissues/listing",
      document: "employeesadmin_staff/listingdocs",
      msg: "empmsg/listing",
      order: "shopsorder/listing",
      leave: "shiftsleaves/listing",
      ot: "shiftsotrequest/listing",
    };

    const fetchMap = {
      complaint: "user/getunreadunseenCountcomplaint",
      document: "user/getunreadDocumentCount",
      msg: "user/getunreadunseenCountmsg",
      leave: "user/getunreadunseenCountleave",
      ot: "user/getunreadunseenCountOt",
    };

    const permKeyMap = {
      complaint: "comnot",
      issue: "issue",
      document: "docnot",
      msg: "msgnot",
      order: "ordernot",
      leave: "leavenot",
      ot: "otnot",
    };

    if (checkPermission(permKeyMap[e])) {
      toastr.error(TF("{0}", T("Error")), add_msg);
      return;
    }

    if (fetchMap[e]) {
      fetch(`${myConstClass.BASE_URL}${fetchMap[e]}`)
        .then((res) => res.json())
        .catch((err) => console.error(err));
    }

    window.location.href = `/${myConstClass.TENANT_PAGE_PATH}${routes[e]}`;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  show_qrcode() {
    localStorage.setItem("custom", "1");
    window.location.href = "/SignInCustom";
  }

  render() {
    const { sidebar } = this.props;
    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");
    const is_google_translator =
      localStorage.getItem("is_google_transaltor") === "1";
    const is_subadmin = localStorage.getItem("is_subadmin") === "1";
    const is_payroll_privilege =
      localStorage.getItem("is_payroll_privilage") !== "0";
    const on_subadmin_dashboard = localStorage.getItem("on_subadmin_dashboard");
    const common_login = localStorage.getItem("common_login") === "1";
    const lang = localStorage.getItem("lang");

    const {
      unseencount = [],
      documentcount,
      complaintcount,
      msgcount,
      leavecount,
      issueLength,
      ordercount,
      otcount,
    } = this.state;

    const balance_div_urlnew = (() => {
      if (
        is_subadmin &&
        !is_payroll_privilege &&
        login_type === "emp" &&
        on_subadmin_dashboard === "2"
      ) {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(1)}
          >
            Change To Sub Admin Dashboard
          </Button>
        );
      }
      if (
        is_payroll_privilege &&
        login_type === "emp" &&
        on_subadmin_dashboard === "2"
      ) {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(2)}
          >
            Change To Payroll Admin Dashboard
          </Button>
        );
      }
      if (login_type === "sub_admin" && on_subadmin_dashboard === "1") {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(3)}
          >
            Change To Emp Dashboard
          </Button>
        );
      }
      return null;
    })();

    const custom_url =
      localStorage.getItem("is_custom") === "1" &&
      !localStorage.getItem("custom") ? (
        <Button
          className="button_change_dashboard"
          onClick={this.change_custom}
        >
          Custom
        </Button>
      ) : null;

    const back_common_url = common_login ? (
      <Button
        className="button_change_dashboard"
        onClick={this.change_common_url}
      >
        Back
      </Button>
    ) : null;

    // Helper to render notification icon groups
    // const renderIconBadge = (Icon, count, action, titleFalse, titleTrue) => (
    //   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
    //     <DropdownToggle
    //       nav
    //       className="nav-icon dropdown-toggle position-relative"
    //     >
    //       <FontAwesomeIcon
    //         icon={Icon}
    //         className="align-middle"
    //         onClick={() => this.edit(action)}
    //       />
    //       {count ? (
    //         <span className="float-right badge badge-error">{count}</span>
    //       ) : null}
    //     </DropdownToggle>
    //   </UncontrolledDropdown>
    // );
const renderIconBadge = (Icon, count, action, titleFalse, titleTrue, tooltipText) => {
  const tooltip = (
    <Tooltip id={`tooltip-${action}`}>
      {tooltipText || titleTrue || titleFalse}
    </Tooltip>
  );

  return (
    <UncontrolledDropdown nav inNavbar className="ml-lg-1" key={action}>
      <DropdownToggle
        nav
        className="nav-icon dropdown-toggle position-relative"
      >
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <div onClick={() => this.edit(action)} style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={Icon} className="align-middle" />
            {count ? (
              <span className="float-right badge badge-error">{count}</span>
            ) : null}
          </div>
        </OverlayTrigger>
      </DropdownToggle>
    </UncontrolledDropdown>
  );
};

    return (
      <Navbar expand className="navbar-theme">
        {!sidebar.isOnRight ? (
          <>
            <NavbarToggle />
            <NavbarSearch />
            <Collapse navbar>
              <Nav
                className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
                navbar
              >
                {balance_div_urlnew}
                {back_common_url}
                {is_google_translator ? (
                  <div id="google_translate_elementnav"></div>
                ) : (
                  <div>
                    <LanguageList Language={lang} style={{ display: "none" }} />
                    <label style={{ color: "white" }}>Select Language</label>
                    <select
                      className="custom-language-list"
                      value={lang}
                      onChange={(e) => {
                        localStorage.setItem("lang", e.target.value);
                        window.location.reload();
                      }}
                    >
                      {Object.entries(Config.list).map(([key, val]) => (
                        <option key={key} value={key}>
                          {val.text}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

              {(login_type === "hr_admin") && (
  <>
    {renderIconBadge(faBook, documentcount, "document", "Documents", "Documents", `You have ${documentcount} documents.`)}
    {renderIconBadge(faWeight, otcount, "ot", "OT", "OT Requests", `You have ${otcount} OT requests.`)}
    {renderIconBadge(faExclamationTriangle, complaintcount, "complaint", "Complaint", "Complaints", `You have ${complaintcount} complaints.`)}
    {renderIconBadge(faEnvelopeOpen, msgcount, "msg", "Messages", "Messages", `You have ${msgcount} messages.`)}
    {renderIconBadge(faTable, leavecount, "leave", "Leave", "Leave Requests", `You have ${leavecount} leave requests.`)}
    {renderIconBadge(faHandsHelping, issueLength, "issue", "Issues", "Issues", `You have ${issueLength} issues to handle.`)}
    {renderIconBadge(faShoppingCart, ordercount, "order", "Orders", "Orders", `You have ${ordercount} orders.`)}
  </>
)}

                <UncontrolledDropdown nav inNavbar className="ml-lg-1">
                  <DropdownToggle nav caret>
                    <FontAwesomeIcon icon={faCog} className="align-middle" />
                  </DropdownToggle>
                  <DropdownMenu right>
                    <Link
                      to={{
                        pathname: `/${myConstClass.TENANT_PAGE_PATH}${
                          login_type === "hr_admin" ||
                          login_type === "super_admin"
                            ? "myprofile/Add"
                            : "employees/profile"
                        }`,
                        state: {
                          _id: login_type === "hr_admin" ? admin_id : login_id,
                        },
                      }}
                    >
                      <DropdownItem>
                        <FontAwesomeIcon
                          icon={faArrowAltCircleRight}
                          className="mr-2 align-middle"
                        />
                        My Profile
                      </DropdownItem>
                    </Link>
                    <Link to="/">
                      <DropdownItem onClick={logout}>
                        <FontAwesomeIcon
                          icon={faArrowAltCircleRight}
                          className="mr-2 align-middle"
                        />
                        Sign out
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </>
        ) : (
          <>
            <Collapse navbar>
              <Nav
                className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
                navbar
              >
                {back_common_url}
                {/* Similar minimized mobile dropdowns... */}
              </Nav>
            </Collapse>
            <NavbarSearch />
            <NavbarToggle />
          </>
        )}
      </Navbar>
    );
  }

  //   render() {
  //     //alert(localStorage.getItem("lang"));
  //     const { sidebar } = this.props;
  //     var admin_id = localStorage.getItem("uname");
  //     let login_id = localStorage.getItem("login_id");
  //     var login_type = localStorage.getItem("login_type");
  //     //alert(on_subadmin_dashboard);
  //     var is_google_transaltor = localStorage.getItem("is_google_transaltor");
  //     var is_subadmin = localStorage.getItem("is_subadmin");
  //     // alert(is_subadmin);
  //     // alert(login_type);
  //     // alert(is_payroll_privilage);
  //     var is_payroll_privilage = localStorage.getItem("is_payroll_privilage");
  //     //alert(is_payroll_privilage);
  //     var mcount = localStorage.getItem("mcount");
  //     var ocount = localStorage.getItem("ocount");
  //     var on_subadmin_dashboard = localStorage.getItem("on_subadmin_dashboard");
  //     // alert(String(is_subadmin).trim());
  //     // alert(String(is_payroll_privilage).trim());
  //     // alert(String(login_type).trim());
  //     // alert(String(on_subadmin_dashboard).trim());
  //      let balance_div_urlnew;
  //     // if (is_subadmin == "1" && is_payroll_privilage == "0" && login_type == "emp" && on_subadmin_dashboard==='2') {
  //     //   //  balance_div_urlnew=<a style={{margin:"0rem 1.50rem 1.50rem 0rem",border: "#6f42c1 1px solid",color: "#6f42c1",padding: "0.10rem 0.90rem 0.30rem 0.90rem",textDecoration: 'none',borderRadius:'0.2rem',cursor:'Pointer'}} class="mr-1 mb-1 btn btn-outline-secondary" onClick={() =>this.change_dashboard()}  >Login</a>;
  //     if (
  //       String(is_subadmin).trim() === "1" &&
  //       String(is_payroll_privilage).trim() === "0" &&
  //       String(login_type).trim() === "emp" &&
  //       String(on_subadmin_dashboard).trim() === "2"
  //     ) {
  //       balance_div_urlnew = (
  //         <Button
  //           className="button_change_dashboard"
  //           onClick={() => this.change_dashboard(1)}
  //         >
  //           {TF("{0}", T("Change"))} {TF("{0}", T("To"))}{" "}
  //           {TF("{0}", T("Sub Admin"))} {TF("{0}", T("Dashboard"))}
  //         </Button>
  //       );
  //     } else if (is_payroll_privilage != "0" && login_type == "emp" && on_subadmin_dashboard==='2') {
  //       //  balance_div_urlnew=<a style={{margin:"0rem 1.50rem 1.50rem 0rem",border: "#6f42c1 1px solid",color: "#6f42c1",padding: "0.10rem 0.90rem 0.30rem 0.90rem",textDecoration: 'none',borderRadius:'0.2rem',cursor:'Pointer'}} class="mr-1 mb-1 btn btn-outline-secondary" onClick={() =>this.change_dashboard()}  >Login</a>;

  //       //var is_subadmin = localStorage.setItem('is_subadmin', '1');

  //       balance_div_urlnew = (
  //         <Button
  //           className="button_change_dashboard"
  //           onClick={() => this.change_dashboard(2)}
  //         >
  //           {TF("{0}", T("Change"))} {TF("{0}", T("To"))}{" "}
  //           {TF("{0}", T("Payroll Admin"))} {TF("{0}", T("Dashboard"))}
  //         </Button>
  //       );
  //     }

  //     else if (login_type == "sub_admin" && on_subadmin_dashboard=='1') {
  //       //  balance_div_urlnew=<a style={{margin:"0rem 1.50rem 1.50rem 0rem",border: "#6f42c1 1px solid",color: "#6f42c1",padding: "0.10rem 0.90rem 0.30rem 0.90rem",textDecoration: 'none',borderRadius:'0.2rem',cursor:'Pointer'}} class="mr-1 mb-1 btn btn-outline-secondary" onClick={() =>this.change_dashboard()}  >Login</a>;

  //       //var is_subadmin = localStorage.setItem('is_subadmin', '1');

  //       balance_div_urlnew = (
  //         <Button
  //           className="button_change_dashboard"
  //           onClick={() => this.change_dashboard(3)}
  //         >
  //           {TF("{0}", T("Change"))} {TF("{0}", T("To"))}{" "}
  //           {TF("{0}", T("Emp"))} {TF("{0}", T("Dashboard"))}
  //         </Button>
  //       );
  //     }

  //     else {
  //       balance_div_urlnew = "";
  //     }

  //     let custom_url;
  //     if (
  //       localStorage.getItem("is_custom") == "1" &&
  //       localStorage.getItem("custom") == null
  //     ) {
  //       custom_url = (
  //         <Button
  //           className="button_change_dashboard"
  //           onClick={() => {
  //             this.change_custom();
  //           }}
  //           // onClick={this.show_qrcode}
  //         >
  //           {TF("{0}", T("Custom"))}
  //         </Button>
  //       );
  //     } else {
  //       custom_url = "";
  //     }

  //     let back_coomon_url;
  //     if (localStorage.getItem("common_login") == "1") {
  //       back_coomon_url = (
  //         <Button
  //           className="button_change_dashboard"
  //           onClick={() => {
  //             this.change_common_url();
  //           }}
  //           // onClick={this.show_qrcode}
  //         >
  //           {TF("{0}", T("Back"))}
  //         </Button>
  //       );
  //     } else {
  //       back_coomon_url = "";
  //     }
  //     let admin_path, tenpath;
  //     if (login_type == "hr_admin") {
  //       tenpath = "myprofile/Add";
  //     } else {
  //       tenpath = "employees/add";
  //     }

  //     admin_path = "/";

  //     return (
  //       <Navbar expand className="navbar-theme">
  //         {!sidebar.isOnRight ? (
  //           <React.Fragment>
  //             <NavbarToggle />

  //             <NavbarSearch />

  //             <Collapse navbar>
  //               <Nav
  //                 className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
  //                 navbar
  //               >
  //                {balance_div_urlnew}
  //                 {/* {custom_url} */}
  //                 {back_coomon_url}
  //                 {is_google_transaltor == "1" ? (
  //                   <div id="google_translate_elementnav"></div>
  //                 ) : (
  //                   <div>
  //                     <LanguageList
  //                       Language={localStorage.getItem("lang")}
  //                       style={{ display: "none" }}
  //                     />
  //                     <label style={{ color: "white" }}>
  //                       {TF("{0}", T("Select"))} {TF("{0}", T("Language"))}
  //                     </label>{" "}
  //                     <select //style={{margintop:'10px'}}
  //                       className="custom-language-list"
  //                       value={localStorage.getItem("lang")}
  //                       // onChange={this.changelang}
  //                       onChange={(e) => {
  //                         localStorage.setItem("lang", e.target.value);

  //                         localStorage.setItem("change", true);

  //                         // alert(e.target.value);
  //                         this.setState({ language: e.target.value });
  //                         // this.setState({ change: true})

  //                         window.location.reload();

  //                         //window.location.reload();

  //                         if (localStorage.getItem("change") == true) {
  //                           //alert();
  //                           //  if( !localStorage.getItem('firstLoad') )
  //                           //  {
  //                           //  localStorage['firstLoad'] = true;
  //                           window.location.reload();
  //                           localStorage.setItem("change", false);
  //                         }
  //                       }}
  //                     >
  //                       {Object.keys(Config.list).map((key) => (
  //                         <option key={key} value={key}>
  //                           {Config.list[key].text}
  //                         </option>
  //                       ))}
  //                     </select>
  //                   </div>
  //                 )}

  //                 {login_type == "hr_admin" ? (
  //                   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                     {/* <div  id="google_translate_element"></div> */}
  //                     <DropdownToggle nav caret>
  //                       <FontAwesomeIcon icon={faBell} className="align-middle" />
  //                       {/* <span class="indicator"></span> */}
  //                       {/* <span class="float-right badge badge-error"> </span> */}
  //                       {/* {this.state.complaintcount != 0 && this.state.complaintcount || this.state.msgcount != 0 && this.state.msgcount || this.state.leavecount != 0 && this.state.leavecount != null ? */}

  //                       {this.state.unseencount.length != 0 ? (
  //                         // <span class="indicatorno">
  //                         <span class="float-right badge badge-error">
  //                           {this.state.unseencount.length}
  //                         </span>
  //                       ) : (
  //                         // </span>
  //                         ""
  //                       )}
  //                     </DropdownToggle>
  //                     <DropdownMenu right>
  //                       {(this.state.documentcount != 0 &&
  //                         this.state.documentcount != null &&
  //                         login_type == "hr_admin") ||
  //                       (this.state.documentcount != 0 &&
  //                         this.state.documentcount != null &&
  //                         login_type == "sub_admin") ? (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("document");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faExclamationTriangle}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {this.state.documentcount}{" "}
  //                             {T("Documents Expired in 30 days")}
  //                           </DropdownItem>
  //                         </Link>
  //                       ) : (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("document");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faExclamationTriangle}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {T("No")} {T("Documents Expired in 30 days")}
  //                           </DropdownItem>
  //                         </Link>
  //                       )}

  //                       {(this.state.complaintcount != 0 &&
  //                         this.state.complaintcount != null &&
  //                         login_type == "hr_admin") ||
  //                       (this.state.complaintcount != 0 &&
  //                         this.state.complaintcount != null &&
  //                         login_type == "sub_admin") ? (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("complaint");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faExclamationTriangle}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {this.state.complaintcount} {T("New")}{" "}
  //                             {T("Comments")}
  //                           </DropdownItem>
  //                         </Link>
  //                       ) : (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("complaint");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faExclamationTriangle}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {T("No")} {T("New")} {T("Comments")}
  //                           </DropdownItem>
  //                         </Link>
  //                       )}

  //                       {(this.state.msgcount != 0 &&
  //                         this.state.msgcount != null &&
  //                         login_type == "hr_admin") ||
  //                       (this.state.msgcount != 0 &&
  //                         this.state.msgcount != null &&
  //                         login_type == "sub_admin") ||
  //                       (this.state.msgcount != 0 &&
  //                         this.state.msgcount != null &&
  //                         login_type == "emp") ? (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("msg");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faEnvelopeOpen}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {this.state.msgcount} {T("New")} {T("Messages")}{" "}
  //                             {T("Arrived")}
  //                           </DropdownItem>
  //                         </Link>
  //                       ) : (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("msg");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faEnvelopeOpen}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {T("No")} {T("Messages")} {T("Arrived")}
  //                           </DropdownItem>
  //                         </Link>
  //                       )}

  //                       {(this.state.leavecount != 0 &&
  //                         this.state.leavecount != null &&
  //                         login_type == "hr_admin") ||
  //                       (this.state.documentcount != 0 &&
  //                         this.state.documentcount != null &&
  //                         login_type == "sub_admin") ? (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("leave");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faEnvelopeOpen}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {this.state.leavecount} {T("Applied")} {T("Leaves")}{" "}
  //                             {T("today")}
  //                           </DropdownItem>
  //                         </Link>
  //                       ) : (
  //                         <Link>
  //                           <DropdownItem
  //                             onClick={() => {
  //                               this.edit("leave");
  //                             }}
  //                           >
  //                             <FontAwesomeIcon
  //                               icon={faEnvelopeOpen}
  //                               fixedWidth
  //                               className="mr-2 align-middle"
  //                             />
  //                             {T("No")} {T("Applied")} {T("Leaves")} {T("today")}
  //                           </DropdownItem>
  //                         </Link>
  //                       )}
  //                     </DropdownMenu>
  //                   </UncontrolledDropdown>
  //                 ) : (
  //                   ""
  //                 )}

  //                 {/* {this.state.complaintcount != 0 && this.state.complaintcount != null && login_type == 'hr_admin' ? (

  // <UncontrolledDropdown nav inNavbar className="ml-lg-1" >
  // <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
  //   <FontAwesomeIcon icon={faExclamationTriangle} className="align-middle" onClick={() =>this.edit('complaint')} />
  //           <span class="float-right badge badge-error">

  //           {this.state.complaintcount}</span>
  // </DropdownToggle>

  // </UncontrolledDropdown>

  //     ):this.state.complaintcount == 0 || this.state.complaintcount == null && login_type == 'hr_admin'?(

  // <UncontrolledDropdown nav inNavbar className="ml-lg-1" >
  // <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
  //   <FontAwesomeIcon icon={faExclamationTriangle} className="align-middle" onClick={() =>this.edit('complaint')} />

  // </DropdownToggle>

  // </UncontrolledDropdown>

  //     ):''
  // }

  // {this.state.msgcount != 0 && this.state.msgcount != null && login_type == 'hr_admin' ? (
  //   <UncontrolledDropdown nav inNavbar className="ml-lg-1" >
  // <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
  //   <FontAwesomeIcon icon={faEnvelopeOpen} className="align-middle" onClick={() =>this.edit('msg')} />
  //           <span class="float-right badge badge-error">

  //           {this.state.msgcount}</span>
  // </DropdownToggle>

  // </UncontrolledDropdown>
  //  ):this.state.msgcount == 0 || this.state.msgcount == null && login_type == 'hr_admin'?(
  // <UncontrolledDropdown nav inNavbar className="ml-lg-1" >
  // <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
  //   <FontAwesomeIcon icon={faEnvelopeOpen} className="align-middle" onClick={() =>this.edit('msg')} />

  // </DropdownToggle>

  // </UncontrolledDropdown>

  // ):''
  // } */}

  //                 {this.state.issueLength != 0 &&
  //                 this.state.issueLength != null &&
  //                 login_type == "hr_admin" ? (
  //                   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                     <DropdownToggle
  //                       nav
  //                       className="nav-icon dropdown-toggle position-relative"
  //                     >
  //                       <FontAwesomeIcon
  //                         icon={faHandsHelping}
  //                         className="align-middle"
  //                         onClick={() => this.edit("issue")}
  //                       />
  //                       <span class="float-right badge badge-error">
  //                         {this.state.issueLength}
  //                       </span>
  //                     </DropdownToggle>
  //                   </UncontrolledDropdown>
  //                 ) : this.state.issueLength == 0 ||
  //                   (this.state.issueLength == null &&
  //                     login_type == "hr_admin") ? (
  //                   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                     <DropdownToggle
  //                       nav
  //                       className="nav-icon dropdown-toggle position-relative"
  //                     >
  //                       <FontAwesomeIcon
  //                         icon={faHandsHelping}
  //                         className="align-middle"
  //                         onClick={() => this.edit("issue")}
  //                       />
  //                     </DropdownToggle>
  //                   </UncontrolledDropdown>
  //                 ) : (
  //                   ""
  //                 )}

  //                 {this.state.ordercount != 0 &&
  //                 this.state.ordercount != null &&
  //                 login_type == "hr_admin" ? (
  //                   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                     <DropdownToggle
  //                       nav
  //                       className="nav-icon dropdown-toggle position-relative"
  //                     >
  //                       <FontAwesomeIcon
  //                         icon={faShoppingCart}
  //                         className="align-middle"
  //                         onClick={() => this.edit("order")}
  //                       />
  //                       <span class="float-right badge badge-error">
  //                         {this.state.ordercount}
  //                       </span>
  //                     </DropdownToggle>
  //                   </UncontrolledDropdown>
  //                 ) : this.state.ordercount == 0 ||
  //                   (this.state.ordercount == null &&
  //                     login_type == "hr_admin") ? (
  //                   <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                     <DropdownToggle
  //                       nav
  //                       className="nav-icon dropdown-toggle position-relative"
  //                     >
  //                       <FontAwesomeIcon
  //                         icon={faShoppingCart}
  //                         className="align-middle"
  //                         onClick={() => this.edit("order")}
  //                       />
  //                     </DropdownToggle>
  //                   </UncontrolledDropdown>
  //                 ) : (
  //                   ""
  //                 )}

  //                 {/* for google translator */}

  //                 <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                   {/* <div  id="google_translate_element"></div> */}
  //                   <DropdownToggle nav caret>
  //                     <FontAwesomeIcon icon={faCog} className="align-middle" />
  //                   </DropdownToggle>
  //                   <DropdownMenu right>
  //                     {login_type == "hr_admin" || login_type == "super_admin"? (
  //                       // if(login_type == 'hr_admin'){
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "myprofile/Add",
  //                           state: {
  //                             _id: { admin_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     ) : (
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "employees/profile",
  //                           state: {
  //                             _id: { login_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     )}

  //                     <Link to={admin_path}>
  //                       <DropdownItem
  //                         onClick={() => {
  //                           logout();
  //                         }}
  //                       >
  //                         <FontAwesomeIcon
  //                           icon={faArrowAltCircleRight}
  //                           fixedWidth
  //                           className="mr-2 align-middle"
  //                         />

  //                         {T("Sign out")}
  //                       </DropdownItem>
  //                     </Link>
  //                   </DropdownMenu>
  //                 </UncontrolledDropdown>
  //               </Nav>
  //             </Collapse>
  //           </React.Fragment>
  //         ) : (
  //           <React.Fragment>
  //             <Collapse navbar>
  //               <Nav
  //                 className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
  //                 navbar
  //               >
  //                 {back_coomon_url}
  //                 {mcount != 0 && mcount != null && login_type == "hr_admin" ? (
  //                   <NavbarDropdown
  //                     //header="New Messages"
  //                     // footer="Show all messages"
  //                     icon={faEnvelopeOpen}
  //                     // count={mcount}
  //                     // style={{'marginBottom':'5px'}}
  //                     indicator
  //                     active
  //                   >
  //                     {/* {messages.map((item, key) => {
  //         return (
  //           <NavbarDropdownItem
  //             key={key}
  //             icon={
  //               <img
  //                 className="avatar img-fluid rounded-circle"
  //                 src={item.avatar}
  //                 alt={item.name}
  //               />
  //             }
  //             title={item.name}
  //             description={item.description}
  //             time={item.time}
  //             spacing
  //           />
  //         );
  //       })}*/}
  //                   </NavbarDropdown>
  //                 ) : mcount == 0 ||
  //                   (mcount == null && login_type == "hr_admin") ? (
  //                   <NavbarDropdown
  //                     //  header="New Messages"
  //                     // footer="Show all messages"
  //                     icon={faEnvelopeOpen}
  //                     active
  //                     // style={{'marginBottom':'5px'}}
  //                   >
  //                     {/* {messages.map((item, key) => {
  //         return (
  //           <NavbarDropdownItem
  //             key={key}
  //             icon={
  //               <img
  //                 className="avatar img-fluid rounded-circle"
  //                 src={item.avatar}
  //                 alt={item.name}
  //               />
  //             }
  //             title={item.name}
  //             description={item.description}
  //             time={item.time}
  //             spacing
  //           />
  //         );
  //       })}*/}
  //                   </NavbarDropdown>
  //                 ) : (
  //                   ""
  //                 )}
  //                 {ocount != 0 && ocount != null && login_type == "hr_admin" ? (
  //                   <NavbarDropdown
  //                     //header="New Orders"
  //                     // footer="Show all Orders"
  //                     icon={faBell}
  //                     //count={ocount}
  //                     indicator
  //                   >
  //                     {/* {notifications.map((item, key) => {
  //         let icon = (
  //           <FontAwesomeIcon icon={faEnvelopeOpen} className="text-warning" />
  //         );

  //         if (item.type === "important") {
  //           icon = <FontAwesomeIcon icon={faBell} className="text-danger" />;
  //         }

  //         if (item.type === "login") {
  //           icon = (
  //             <FontAwesomeIcon icon={faBuilding} className="text-primary" />
  //           );
  //         }

  //         if (item.type === "request") {
  //           icon = (
  //             <FontAwesomeIcon icon={faBellSlash} className="text-success" />
  //           );
  //         }

  //         return (
  //           <NavbarDropdownItem
  //             key={key}
  //             icon={icon}
  //             title={item.title}
  //             description={item.description}
  //             time={item.time}
  //           />
  //         );
  //       })}*/}
  //                   </NavbarDropdown>
  //                 ) : ocount == 0 ||
  //                   (ocount == null && login_type == "hr_admin") ? (
  //                   <NavbarDropdown
  //                     // header="New Orders"

  //                     icon={faBell}
  //                     // count={ocount}
  //                     active
  //                   >
  //                     {/* {notifications.map((item, key) => {
  //         let icon = (
  //           <FontAwesomeIcon icon={faEnvelopeOpen} className="text-warning" />
  //         );

  //         if (item.type === "important") {
  //           icon = <FontAwesomeIcon icon={faBell} className="text-danger" />;
  //         }

  //         if (item.type === "login") {
  //           icon = (
  //             <FontAwesomeIcon icon={faBuilding} className="text-primary" />
  //           );
  //         }

  //         if (item.type === "request") {
  //           icon = (
  //             <FontAwesomeIcon icon={faBellSlash} className="text-success" />
  //           );
  //         }

  //         return (
  //           <NavbarDropdownItem
  //             key={key}
  //             icon={icon}
  //             title={item.title}
  //             description={item.description}
  //             time={item.time}
  //           />
  //         );
  //       })}*/}
  //                   </NavbarDropdown>
  //                 ) : (
  //                   ""
  //                 )}

  //                 {/* for google translator */}

  //                 <UncontrolledDropdown nav inNavbar className="ml-lg-1">
  //                   <DropdownToggle nav caret>
  //                     <FontAwesomeIcon icon={faCog} className="align-middle" />
  //                   </DropdownToggle>
  //                   <DropdownMenu right>
  //                     {/* {login_type == "hr_admin" ? (
  //                       // if(login_type == 'hr_admin'){
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "myprofile/Add",
  //                           state: {
  //                             _id: { admin_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     ) : (
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "employees/profile",
  //                           state: {
  //                             _id: { login_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     )} */}
  //                     {login_type == "hr_admin" || login_type == "super_admin" ? (
  //                       // if(login_type == 'hr_admin'){
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "myprofile/Add",
  //                           state: {
  //                             _id: { admin_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     ) : (
  //                       <Link
  //                         to={{
  //                           pathname:
  //                             "/" +
  //                             myConstClass.TENANT_PAGE_PATH +
  //                             "employees/profile",
  //                           state: {
  //                             _id: { login_id },
  //                           },
  //                         }}
  //                       >
  //                         {" "}
  //                         <DropdownItem>
  //                           <FontAwesomeIcon
  //                             icon={faArrowAltCircleRight}
  //                             fixedWidth
  //                             className="mr-2 align-middle"
  //                           />
  //                           {T("My Profile")}
  //                         </DropdownItem>
  //                       </Link>
  //                     )}
  //                     <Link to={admin_path}>
  //                       <DropdownItem
  //                         onClick={() => {
  //                           logout();
  //                         }}
  //                       >
  //                         <FontAwesomeIcon
  //                           icon={faArrowAltCircleRight}
  //                           fixedWidth
  //                           className="mr-2 align-middle"
  //                         />
  //                         {T("Sign out")}
  //                       </DropdownItem>
  //                     </Link>
  //                   </DropdownMenu>
  //                 </UncontrolledDropdown>
  //               </Nav>
  //             </Collapse>

  //             <NavbarSearch />
  //             <NavbarToggle />
  //             {/* <div  id="google_translate_element"></div> */}
  //           </React.Fragment>
  //         )}
  //       </Navbar>
  //     );
  //   }
}

// const NavbarComponent = ({ sidebar }) => {
//   return (
//     <Navbar expand className="navbar-theme">
//       {!sidebar.isOnRight ? (
//         <React.Fragment>
//           <NavbarToggle />
//           <NavbarSearch />
//           <NavbarDropdowns />
//         </React.Fragment>
//       ) : (
//         <React.Fragment>
//           <NavbarDropdowns />
//           <NavbarSearch />
//           <NavbarToggle />
//         </React.Fragment>
//       )}
//     </Navbar>
//   );
// };

export default connect((store) => ({
  sidebar: store.sidebar,
}))(Navbarnew);
